import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/tumblr': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144h-47.5c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1 0.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4v133.2c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5 0.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-0.4 14.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/tumblr.js
// module id = 1061
// module chunks = 0